import React, { useEffect, useState } from 'react';
import styles from '../styles.module.scss';

export default function PropertyKeyInput({
    propertyKey,
    pathId,
    onRename,
}: {
    propertyKey: string;
    pathId: string;
    onRename: (nextKey: string) => string | null;
}) {
    const [draftKey, setDraftKey] = useState(propertyKey);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setDraftKey(propertyKey);
        setError(null);
    }, [propertyKey]);

    const commit = () => {
        const nextKey = draftKey.trim();
        const nextError = onRename(nextKey);
        setError(nextError);
        if (!nextError) {
            setDraftKey(nextKey);
        }
    };

    return (
        <label
            className={styles.extractionSchemaKeyField}
            title="Auto-generated from the field name. Used in exported data and encounter mapping."
        >
            <span>Data key</span>
            <input
                value={draftKey}
                onChange={(event) => {
                    setDraftKey(event.target.value);
                    setError(null);
                }}
                onBlur={commit}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        event.currentTarget.blur();
                    }
                }}
                aria-invalid={!!error}
                aria-describedby={error ? `extraction-schema-key-error-${pathId}` : undefined}
                data-test-id={`extraction-schema-key-${pathId}`}
            />
            {error ? (
                <small id={`extraction-schema-key-error-${pathId}`} className={styles.extractionSchemaFieldError}>
                    {error}
                </small>
            ) : null}
        </label>
    );
}
